<template lang='pug'>
  .container-pts.outline(
    tabindex="-1", v-focus="",
    @keyup.49="punchTimelog('start')",@keyup.97="punchTimelog('start')",
    @keyup.50="punchTimelog('stPause')",@keyup.98="punchTimelog('stPause')",
    @keyup.51="punchTimelog('endPause')",@keyup.99="punchTimelog('endPause')",
    @keyup.52="punchTimelog('end')",@keyup.100="punchTimelog('end')",
  )

    template(v-if="processing")
      CurrentTime
      div.columns.is-vcentered.is-mobile
        div.column.has-text-centered
          h1(v-if="processing") Seu ponto está sendo gravado...
      div
        span
    template(v-if="!processing")
      modal(name="ptsModal", :adaptive="true", width="70%", height="auto", :scrollable="true")
        PtsBox

      CurrentTime

      .has-text-centered(v-if="fallback")
        p Os pontos já batidos não estão sendo mostrados temporariamente. Não se preocupe, eles estão salvos.

      .has-text-centered(id="selecionaponto")
        .columns
          .column
            PtButton(:displayPts="todayPts.entrada", kind="start", :showRecaptcha="info.showRecaptcha", :recordingKind="recordingStart", :recording="recording", :seconds="seconds", @punchTimelog="punchTimelog", id="botaoentrada")

          .column
            PtButton(:displayPts="todayPts.pausa", kind="stPause", :showRecaptcha="info.showRecaptcha", :recordingKind="recordingStPause", :recording="recording", :seconds="seconds", @punchTimelog="punchTimelog")

        .columns
          .column
            PtButton(:displayPts="todayPts.retorno", kind="endPause", :showRecaptcha="info.showRecaptcha", :recordingKind="recordingEndPause", :recording="recording", :seconds="seconds", @punchTimelog="punchTimelog")

          .column
            PtButton(:displayPts="todayPts.saida", kind="end", :showRecaptcha="info.showRecaptcha", :recordingKind="recordingEnd", :recording="recording", :seconds="seconds", @punchTimelog="punchTimelog")

        .columns
          .column
            Button3d(
            @click="ptsModal",
            color="primary",
            :block="true",
            size="large") PONTOS REGISTRADOS

        .columns(v-if="visual.webButtonBack")
          .column
            Button3d(color="info", size="large", @click="backPreviousPage", :block="true") voltar


</template>
<script>
import swal from 'sweetalert2'
import CurrentTime from '@/common/CurrentTime.vue'
import PtsBox from './PtsBox.vue'
import PtButton from './PtButton'
import { mapState, mapGetters } from 'vuex'
import { GEO_LOCATION_ERRORS } from './state'
import config from '../../config'

export default {
  mounted: async function () {
    this.verificarPermissaoDeUsoDoMicrofone()
    this.$store.commit('punchTimelog/resetState')

    if (!this.$store.state.punchTimelog.employee && !this.$store.state.punchTimelog.fallback) {
      console.warn('Redirect to password cuz store has no employee')
      this.$router.push({name: 'password'})
    }
    // this.$store.commit('punchTimelog/screenTimeout', screenTimeout)
  },
  created () {
    if (this.$store.state.accessData.cognitoInfo && this.$store.state.accessData.cognitoInfo.isSamlLogin) {
      this.startPeriodicSSOPtsUpdater()
    } else {
      this.startPeriodicGoToPassword()
    }
  },
  beforeDestroy () {
    this.$store.commit('punchTimelog/resetState', true)
    if (this.periodicSSOPtsUpdaterWorker) {
      this.periodicSSOPtsUpdaterWorker.terminate()
    }
  },
  components: {
    CurrentTime, PtButton, PtsBox,
  },
  data () {
    return {
      seconds: 3,
      recordingStart: false,
      recordingStPause: false,
      recordingEndPause: false,
      recordingEnd: false,
      recording: false,
      GEO_LOCATION_ERRORS,
      periodicSSOPtsUpdaterWorker: false
    }
  },
  watch: {
    seconds: function (val) {
      if (val <= 0) {
        this.$store.state.punchTimelog.recordVoice = false
      }
    }
  },
  computed: {
    ...mapState('punchTimelog', ['kind', 'processing', 'recordVoice', 'geoLocationError', 'todayPts', 'monthPts', 'pwd', 'fallback']),
    ...mapGetters(['visual']),
    info () {
      const {accessData} = this.$store.state

      return {
        lineInfo: accessData.lineInfo || false,
        pts: accessData.pts || false,
        employee: accessData.employeeId || false,
        fingerprint: accessData.employeeId || false,
        doubleCheck: this.$store.state.punchTimelog.doubleCheck || false,
        allowVoice: this.$store.state.punchTimelog.recordVoice || false,
        compMan: accessData.compMan || false,
        showRecaptcha: accessData.browserRecord.recaptcha || false
      }
    },
    empregadoUsaGravarPontoComVoz () {
      return this.info.allowVoice
    }
  },
  methods: {
    async verificarPermissaoDeUsoDoMicrofone () {
      if (!this.empregadoUsaGravarPontoComVoz) {
        return
      }
      try {
        await navigator.mediaDevices.getUserMedia({
          audio: true
        })
      } catch (erro) {
        if (erro instanceof DOMException) {
          this.mostrarModalDeConfirmacaoDePontoSemVoz()
        }
      }
    },
    async mostrarModalDeConfirmacaoDePontoSemVoz () {
      const resposta = await swal({
        type: 'warning',
        title: 'Permissão ao microfone não concedida',
        text: 'Notamos que a permissão não foi habilitada em seu navegador. Se desejar, poderá dar a permissão e tentar bater ponto novamente. Ao clicar em continuar você estará concordando em realizar o registro de ponto sem gravação de voz.',
        showCancelButton: true,
        cancelButtonText: 'Voltar',
        confirmButtonText: 'Continuar'
      })
      const selecionouContinuar = resposta.value === true
      if (!selecionouContinuar) {
        this.redirecionarParaTelaDeSenha()
      }
    },
    redirecionarParaTelaDeSenha () {
      this.$router.push({
        name: 'password'
      })
    },
    getCoordinates() {
      return new Promise(function (resolve, reject) {
        navigator.geolocation.getCurrentPosition(resolve, reject)
      })
    },
    async checkGeoLocation () {
      if (navigator.geolocation) {
        try {
          const position = await this.getCoordinates()
          this.$store.commit('punchTimelog/coordinates', {lat: position.coords.latitude, lon: position.coords.longitude})
        } catch (error) {
          console.warn(error)
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.$store.commit('punchTimelog/geoLocationError', GEO_LOCATION_ERRORS.permissionDenied)
              break
            case error.POSITION_UNAVAILABLE:
              this.$store.commit('punchTimelog/geoLocationError', GEO_LOCATION_ERRORS.positionUnavailable)
              break
            case error.TIMEOUT:
              this.$store.commit('punchTimelog/geoLocationError', GEO_LOCATION_ERRORS.TIMEOUT)
              break
            case error.UNKNOWN_ERROR:
              this.$store.commit('punchTimelog/geoLocationError', GEO_LOCATION_ERRORS.UNKNOWN_ERROR)
              break
          }
        }
      } else {
        console.info("Geolocation is not supported by this browser.")
        this.$store.commit('punchTimelog/noGeoLocationSupport', true)
      }
    },
    sendForm () {
      this.$store.dispatch('punchTimelog/clearScreenTimeout')
      this.$store.dispatch('punchTimelog/preProcessToSaveTimelog', null, {root: true})
    },
    realPunchTimeLog (kind) {
      this.$store.commit('punchTimelog/kind', kind)

      // check if already exist a pt of this kind
      const respectiveNames = {
        start: [this.todayPts.entrada, 'entrada'],
        stPause: [this.todayPts.pausa, 'pausa'],
        endPause: [this.todayPts.retorno, 'retorno'],
        end: [this.todayPts.saida, 'saida']
      }

      if (this.recording || this.processing) {
        swal({
          type: 'info',
          text: `Você já está no processo de registrar ponto`,
          confirmButtonText: 'OK',
        })
      } else if (respectiveNames[kind][0].length !== 0) {
        swal({
          type: 'question',
          text: `Você já registrou um ponto de ${respectiveNames[this.kind][1]}. Deseja continuar mesmo assim?`,
          showCancelButton: true,
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim'
        }).then((result) => {
          if (result.value) {
            if (this.info.allowVoice) {
              this.startRecord(kind)
            } else {
              this.sendForm()
            }
          }
        })

        document.querySelector('.swal2-confirm.swal2-styled').setAttribute('id', 'confirmapontorepetido')
      } else {
        if (this.info.allowVoice) {
          this.startRecord(kind)
        } else {
          this.sendForm()
        }
      }
    },
    async punchTimelog (kind, token) {
      if (this.info.showRecaptcha && token) {
        this.$store.commit('punchTimelog/recaptcha', true)
        this.$store.commit('punchTimelog/token', token)
      }

      if (this.visual && this.visual.webIgnoreLocation) {
        console.warn('ignore location')
      } else {
        await this.checkGeoLocation()
      }

      if (this.info.doubleCheck) {
        const respectiveNames = {
          start: [this.todayPts.entrada, 'entrada'],
          stPause: [this.todayPts.pausa, 'pausa'],
          endPause: [this.todayPts.retorno, 'retorno'],
          end: [this.todayPts.saida, 'saida']
        }

        swal({
          type: 'question',
          text: `Podemos seguir com sua marcação de ${respectiveNames[kind][1]}?`,
          showCancelButton: true,
          cancelButtonText: 'Não',
          confirmButtonText: 'Sim'
        }).then((result) => {
          if (result.value) {
            this.realPunchTimeLog(kind)
          }
        })
      } else {
        this.realPunchTimeLog(kind)
      }
    },
    backPreviousPage () {
      this.$router.push({name: 'password'})
    },
    resetRecording () {
      this.recording = false
      this.recordingStart = false
      this.recordingStPause = false
      this.recordingEndPause = false
      this.recordingEnd = false
    },
    setRecording(kind) {
      this.recording = true;
      if (kind === 'start') {
        this.recordingStart = true;
      } else if (kind === 'stPause') {
        this.recordingStPause = true;
      } else if (kind === 'endPause') {
        this.recordingEndPause = true;
      } else if (kind === 'end') {
        this.recordingEnd = true;
      } else {
        this.recording = false;
      }
    },
    startRecord (kind) {

      function hasGetUserMedia () {
        return !!(navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia)

      }

      if (hasGetUserMedia()) {
        try {
          navigator.mediaDevices.getUserMedia({audio: true})
            .then(stream => {

              this.setRecording(kind)

              const mediaRecorder = new MediaRecorder(stream);
              mediaRecorder.start();

              const audioChunks = [];

              mediaRecorder.addEventListener("dataavailable", event => {
                audioChunks.push(event.data);
              });

              mediaRecorder.addEventListener("stop", () => {
                const audioBlob = new Blob(audioChunks);
                this.$store.commit('punchTimelog/audio', audioBlob)
                this.resetRecording()
                this.sendForm()
              });

              setTimeout(() => {
                mediaRecorder.stop();
              }, 3000);

              setInterval(() => this.seconds--, 1000)

            }, error => {
              this.resetRecording()
              this.sendForm()
          });
        } catch (e) {
          this.resetRecording()
          this.sendForm()
        }
      } else {
        console.warn('dont have enough information')
        alert('getUserMedia() is not supported by your browser')
      }

    },
    ptsModal () {
      let dates = []
      this.monthPts.map((item) => {
        dates.push(item.day)
      })
      this.$modal.show('ptsModal')
    },
    startPeriodicSSOPtsUpdater () {
      if (this.periodicSSOPtsUpdaterWorker) return

      this.periodicSSOPtsUpdaterWorker = new Worker('/js/periodicSSOPtsUpdater.js')

      this.periodicSSOPtsUpdaterWorker.addEventListener('message', (e) => {
        const data = JSON.parse(e.data)
        if (data.success) {
          this.$store.dispatch('register/setSSOData', data)
        }
      })

      this.periodicSSOPtsUpdaterWorker.postMessage(JSON.stringify({
        endPoint: config.baseUrl, ...this.$store.state.accessData.cognitoInfo
      }))
    },
    startPeriodicGoToPassword () {
      setTimeout(() => {
        this.$router.push({name: 'password'})
      }, 360000)
    }
  }
}
</script>

<style scoped>
.outline {
  outline: none;
}

.container-pts {
  margin: 0;
  display: grid;
  grid-template-columns: 1fr;
  /*grid-template-rows: 0.fr 1fr 0.01fr;*/
}
.container-pts h1 {
  margin: 0;
  align-self: center;
}

@media only screen and (min-width: 1000px) {
  .container-pts {
    width: 100%;
    padding: 0 25% 0 25%;
  }
}
@media only screen and (min-width: 800px) and (max-width: 1000px) {
  .container-pts {
    width: 100%;
    padding: 0 15% 0 15%;
    grid-template-rows: 0.1fr 0.8fr;
  }
}
@media only screen and (max-width: 800px) and (min-width: 600px) {
  .container-pts {
    width: 100%;
    padding: 0 10% 0 10%;
    grid-template-rows: 0.1fr 0.8fr;
  }
}
@media only screen and (max-width: 600px) {
  .container-pts {
    width: 100%;
    padding: 0 7% 0 7%;
    grid-template-rows: 0.1fr 0.8fr;
  }
}
</style>
